import pages, { DEFAULT_PAGE_KEY, routeToPage } from '../PageEnums';
import { buildUrl, getCookie, isEmptyObject, isEmptyString, path, isEmptyList, validateMobileNumber } from './index';
import { DEFAULT_TOKEN, SERVER_HOST } from '../../server/apiConstantsServer';
import fetch from 'node-fetch';
import { getConcatanatedUTMData } from './campaignUtils';
import { CREATE_COLD_PROPERTY } from './endpoints';
import DOMPurify from 'isomorphic-dompurify';
import allCountriesData from './country-code-mapping';




export const debounce = (func, delay) => {
  let debounceTimer;
  return function() {
    const context = this;
    const args = arguments;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(context, args), delay);
  };
};



export function extractPageAndCountryIsoCode(pathStr){
  let params = pathStr.split('/');
  while (!params[params.length - 1] && params.length > 2) params.pop();
  
  // params usually contains: ['',{country_iso_code},{pagePath}]
  params[1] = params[1].toLowerCase();
  
  let country_iso_code='', pagePath=params[1];
  if (Object.keys(allCountriesData).includes(params[1].toUpperCase())) {
    // if first parameter is a country iso code (redirection happened through Akamai)
    country_iso_code = params[1];
    if (params.length > 2) {
      pagePath = params[2];
    }
  }
  
  // by default, we are trying to go to landing page
  let pageKey = DEFAULT_PAGE_KEY;
  
  
  // pick the correct pageKey
  if(pagePath in routeToPage)pageKey = routeToPage[pagePath.toLowerCase()];
// find remaining params
  let pageRouteIdx = params.indexOf(path(pages,`${pageKey}.route`,''));
  let countryCodeIdx = params.indexOf(country_iso_code);
  
  // page is always after country code
  if(countryCodeIdx > pageRouteIdx)pageRouteIdx = countryCodeIdx;
  return [country_iso_code,pageKey,params.splice(pageRouteIdx+1)];
}

export const forceLogoutFromServer = (res,country_iso_code,token) => {
  res.cookie('login','true');
  res.clearCookie('user_access_token');
  res.redirect(buildUrl(true,country_iso_code));
  if (!isEmptyString(token)) signOutForServer(token, res);
};

export const getAmount = (arr, occ, rooms, currency, lacSystem) => {
  let amt = Math.floor(arr * occ * rooms * 3.65);
  let predicate;
  if (amt) {
    amt = new String(amt);
    let nAmt = '';
    for (let i = amt.length - 1; i >= 0; i--) {
      let compliment = amt.length - i - 1;
      predicate = compliment % 3 == 2;
      if (lacSystem && compliment > 2) {
        predicate = (compliment - 3) % 2 == 1;
      }
      nAmt = amt[i] + nAmt;
      if (i && predicate && i != amt.length - 1) nAmt = ',' + nAmt;
    }
    amt = nAmt;
  }
  if (!amt) return null;

  if (currency) {
    amt = currency + '  ' + amt;
  }

  return amt;
};

export var isNumber = text => {
  return !isNaN(text);
};

export function hasUpperCase(str) {
  return /[A-Z]/.test(str);
}

export function hasNumber(str) {
  return /[0-9]/.test(str);
}

export function hasSpecialCharacter(str) {
  return /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(str);
}

export function getClientSideCountryCode(iso_code){
  let country_iso_code = getCookie('country_iso_code') || iso_code || 'in';
  // give more preference to country code set at server side
  if(typeof window === 'object') country_iso_code = path(window.__SERVER_DATA__,'translationsData.country_iso_code') || country_iso_code;
  return country_iso_code;
}

export const parseEdgescapeHeader = (edgescapeString) => {
  if(isEmptyString(edgescapeString))return {};
  return edgescapeString.split(',')
      .map((pair) => pair.split('='))
      .reduce((obj, val) => {
        if(isEmptyString(val[0]) || isEmptyString(val[1]))return obj;
        var key = val[0].trim();
        obj[key] = val[1].trim();
        return obj;
  }, {});
};

export const getKeyValues = (obj, keys) => {
  if (obj == null || isEmptyList(keys)) return {};
  let result = {};
  keys.forEach(key => result[key] = obj[key]);
  return result;
};

export const extractUtmData = (obj) => {
  if(isEmptyObject(obj))return {};
  let data = getKeyValues(obj,['utm_source','utm_medium','utm_campaign']);
  Object.keys(data).forEach(key => {
    data[key] = DOMPurify.sanitize(data[key]);
  });
  return data;
};


export const createColdProperty = (redirectedParams, utmData, country) => {
  if(isEmptyString(redirectedParams.email) && isEmptyString(redirectedParams.phone) && !validateMobileNumber(redirectedParams.phone)) return;
  let subSourceCode ;
  if(!isEmptyObject(utmData)) subSourceCode = getConcatanatedUTMData([
    utmData.utm_source,
    utmData.utm_medium,
    utmData.utm_campaign
  ]);
  const reqBody = [{
    'owner_name': redirectedParams.name,
    'owner_primary_mobile_number': redirectedParams.phone,
    'owner_email': redirectedParams.email,
    'sub_source_code': subSourceCode,
    'property_component_type': 'Hotel',
    'sub_source': 'REDIRECTION_DUMP',
    'source': 'OAM',
    'country':country
  }];
  const fetchData = {
    method: 'PUT',
    headers: {
      'content-type': 'application/json',
      'access_token': DEFAULT_TOKEN
    },
    body: JSON.stringify(reqBody)
  };
  
  fetch(SERVER_HOST + CREATE_COLD_PROPERTY, fetchData)
      .then(data => {
        if (!data.ok) {
          console.log('Error in redirected cold property creation', data);
        }
        console.log('Redirected cold property data', data);
        return;
      })
      .catch(e => {
        console.log(e);
      });
};

const signOutForServer = (token, res) => {
  
  const fetchData = {
    method: 'POST',
    headers: {
      'access_token': token
    }
  };
  fetch(SERVER_HOST + '/profiles/sign_out', fetchData)
      .then(function(data) {
        if (!data.ok) {
          console.error(data);
        }
        return data.json();
      })
      .then(d => {
        res.json(d);
      })
      .catch(function(error) {
        console.log('caught error', error.message);
      });
  
};

